type StatusToastProps = {
  message: string
  tone: 'error' | 'success'
  onClose: () => void
}

const toastStyles = {
  error: {
    container:
      'border-[color:var(--app-danger)]/20 bg-[var(--app-danger-soft)] text-[var(--app-text)]',
    badge: 'bg-[color:var(--app-danger)] text-white',
    label: 'Ошибка',
  },
  success: {
    container:
      'border-[color:var(--app-success)]/20 bg-[var(--app-success-soft)] text-[var(--app-text)]',
    badge: 'bg-[color:var(--app-success)] text-white',
    label: 'Готово',
  },
} as const

export const StatusToast = ({ message, tone, onClose }: StatusToastProps) => {
  const style = toastStyles[tone]

  return (
    <div className="fixed inset-x-4 bottom-0 z-50 mx-auto max-w-xl max-h-90 overflow-y-auto">
      <div
        className={`flex items-start gap-3 rounded-[24px] border mb-4 px-4 py-3 shadow-[0_12px_32px_rgba(15,23,42,0.16)] backdrop-blur ${style.container}`}
      >
        <p className="flex-1 whitespace-pre-line text-sm leading-6">
          {message}
        </p>

        <button
          type="button"
          className="rounded-full px-2 py-1 text-sm font-medium text-[var(--app-muted)] transition hover:text-[var(--app-text)]"
          onClick={onClose}
        >
          ✕
        </button>
      </div>
    </div>
  )
}
